export const factorTDEE = {
  'No hago nada de ejercicio': 1.2,
  'Generalmente camino': 1.2,
  'Hago ejercicio de 1 a 2 veces por semana': 1.375,
  'Hago ejercicio de 3 a 5 veces por semana': 1.55,
  'Hago ejercicio de 5 a 7 veces por semana': 1.725,
}
